import { PageHeader } from '@ant-design/pro-layout';
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router';
import { Tabs,  TabsProps } from "antd";
import Subsidiary from '../subsidiary'
import History from "../history";
import Pricing from "../pricing";
import React from "react"; 

type IProps = {};
const Index: React.FC<IProps> = (props: IProps) => {
  const Navigate = useNavigate();

  const location = useLocation();
  const { pathname } = location;

  const items: TabsProps['items'] = [
    {
      key: "/history",
      label: "服务列表",
      children: <History  />,
    },
    {
      key: "/pricing",
      label: "核价信息",
      children: <Pricing />,
    },
    {
      key: "/subsidiary",
      label: "子企业",
      children: <Subsidiary />,
    },
  ];
  
  const onChange = (key: string)=> {
    Navigate(key)
  };

  return (
    <div>
      <PageHeader title="列表信息" onBack={() => Navigate("/dashbord")} style={{ paddingLeft: 0 }}/>
      <Tabs activeKey={pathname} items={items} onChange={onChange} />
    </div>
  );
};

export default Index;